<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill" *ngIf="fieldsConfig.showName">
        <mat-label>Name</mat-label>
        <input matInput [(ngModel)]="searchForm.name" name="name" placeholder="Search by shareholder name" appTextNormalize>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showCategory">
        <mat-label>Category</mat-label>
        <mat-select [(ngModel)]="searchForm.categoryId" name="categoryId" (selectionChange)="onCategoryChange()">
          <mat-option *ngFor="let category of categories$ | async" [value]="category.id">
            {{ category.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.categoryId" mat-icon-button matSuffix (click)="searchForm.categoryId = undefined; onCategoryChange(); $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showSubCategory">
        <mat-label>Sub Category</mat-label>
        <mat-select [(ngModel)]="searchForm.subCategoryId" name="subCategoryId" [disabled]="!searchForm.categoryId" placeholder="Sub Category">
          <mat-option *ngFor="let subCategory of subCategories$ | async" [value]="subCategory.id">
            {{ subCategory.name }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.subCategoryId" mat-icon-button matSuffix (click)="searchForm.subCategoryId = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="fill" class="form-field" *ngIf="fieldsConfig.showUser">
        <mat-label>User</mat-label>
        <mat-select [(ngModel)]="searchForm.createdBy" name="createdBy" placeholder="User">
          <mat-option *ngFor="let user of users$ | async" [value]="user.email">
            {{ user.fullName }}
          </mat-option>
        </mat-select>
        <button *ngIf="searchForm.createdBy" mat-icon-button matSuffix (click)="searchForm.createdBy = undefined; $event.stopPropagation()" tabindex="-1">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="search-actions">
      <mat-checkbox [(ngModel)]="showPyramidMemberships" name="showPyramidMemberships" color="primary" (change)="onShowPyramidMembershipsChange()">Show Pyramid Memberships</mat-checkbox>
      <div class="search-actions-spacer"></div>
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button"  (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
